import { connect } from 'react-redux'

import fetchLandingPageContent from '../../common/actions/fetchLandingPageContent'

const mapStateToProps = (state) => {
  const { html, css } = state.landingPage
  const { currentSite, baseUrl } = state.common
  const { user } = state

  return {
    html,
    css,
    currentSite,
    user,
    baseUrl
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

const createLandingPageContainer = (component) => {
  const container = connect(
    mapStateToProps,
    mapDispatchToProps
  )(component)

  container.loadData = (store, parsedUrl, opts) => {
    return store.dispatch(fetchLandingPageContent(parsedUrl, opts))
  }
  return container
}

export default createLandingPageContainer



// WEBPACK FOOTER //
// ./client/containers/landingPageContainer.js